module.exports = __webpack_public_path__ + "img/order-finish.2a9398ae.png";